import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from '../components/Sidebar';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Imagem do livro aberto
const BOOK_IMAGE = "https://customer-assets.emergentagent.com/job_writers-atelier/artifacts/jj2ewzcl_Untitled%20design.png";

export default function EntryExperience() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [lastBook, setLastBook] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLastWritingSession();
  }, []);

  const fetchLastWritingSession = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/books/in-progress`, {
        withCredentials: true
      });
      
      if (response.data && response.data.length > 0) {
        const books = response.data;
        let mostRecent = books[0];
        let mostRecentTime = 0;
        
        books.forEach(book => {
          const lastTime = localStorage.getItem(`lastTime_${book.book_id}`);
          if (lastTime && parseInt(lastTime) > mostRecentTime) {
            mostRecentTime = parseInt(lastTime);
            mostRecent = book;
          }
        });
        
        setLastBook(mostRecent);
      }
    } catch (error) {
      console.error('Error fetching last session:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleContinueWriting = async () => {
    if (!lastBook) {
      navigate('/meus-livros');
      return;
    }

    const lastChapterId = localStorage.getItem(`lastChapter_${lastBook.book_id}`);
    
    if (lastChapterId) {
      navigate(`/editor/${lastChapterId}`);
    } else {
      try {
        const response = await axios.get(`${API_URL}/api/books/${lastBook.book_id}/chapters`, {
          withCredentials: true
        });
        if (response.data && response.data.length > 0) {
          navigate(`/editor/${response.data[0].chapter_id}`);
        } else {
          navigate(`/livro/${lastBook.book_id}`);
        }
      } catch (error) {
        navigate(`/livro/${lastBook.book_id}`);
      }
    }
  };

  const firstName = user?.name?.split(' ')[0] || 'Autor';

  return (
    <div className="min-h-screen bg-stone-950 flex">
      <Sidebar />
      
      <main className="flex-1 md:ml-64 flex flex-col items-center justify-center relative overflow-hidden">
        {/* Fundo escuro */}
        <div className="absolute inset-0 bg-gradient-to-b from-black via-stone-950 to-black" />

        {/* Mensagem de boas-vindas */}
        <div className="relative z-10 text-center mb-4">
          <h1 className="text-2xl md:text-3xl font-serif text-amber-500 mb-2">
            {firstName}
          </h1>
          <p className="text-base md:text-lg text-stone-300 font-light">
            Que bom que você voltou! Vamos continuar?
          </p>
        </div>

        {/* Livro - Imagem clicável */}
        <div 
          onClick={handleContinueWriting}
          className="relative z-10 cursor-pointer group"
          data-testid="floating-book"
        >
          <div className="book-float-container">
            <img 
              src={BOOK_IMAGE} 
              alt="Seu livro"
              className="book-image w-[1080px] md:w-[1320px] lg:w-[1560px] h-auto object-contain transition-transform duration-500 group-hover:scale-105"
            />
          </div>

          {/* Indicador de clique */}
          <p className="text-amber-500/70 text-sm -mt-4 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            Clique para continuar escrevendo
          </p>
        </div>

        {/* Link alternativo se não houver livro */}
        {!loading && !lastBook && (
          <button
            onClick={() => navigate('/meus-livros')}
            className="relative z-10 mt-8 text-amber-500/70 hover:text-amber-500 text-sm transition-colors"
          >
            Ver todos os livros →
          </button>
        )}

        <style jsx="true">{`
          .book-float-container {
            animation: gentle-float 6s ease-in-out infinite;
            filter: drop-shadow(0 30px 60px rgba(0, 0, 0, 0.6));
          }

          @keyframes gentle-float {
            0%, 100% { 
              transform: translateY(0px);
            }
            50% { 
              transform: translateY(-20px);
            }
          }

          .group:hover .book-float-container {
            animation-play-state: paused;
          }
        `}</style>
      </main>
    </div>
  );
}
